import { StatusListener }    from "./status-listener";
import { OnDestroy, OnInit } from "@angular/core";
import { Cents }             from "../shared/core";
import { Product }           from "../shared-gen/Model/Products/Product";
import { ProductPrice }      from "../shared-gen/Model/PriceLists/ProductPrice";
import { AppStatus }         from "./@models/app-status";
import { DeviceStatusFun }   from "../shared/device/device-status.fun";
import { AppService }        from "./services/app.service";
import { containsAll, nullSafe } from "../shared/utils/core-utils";

export class CanOrder extends StatusListener implements OnInit, OnDestroy {

	protected cartMaximum: number;
	protected theme:string = "general";

	constructor(app: AppService) {
		super(app);
	}

	onStatusChanged(status: AppStatus) {
		super.onStatusChanged(status);
		this.cartMaximum = this.deviceStatus.UIConfig.CartItemsCount;
	}

	async order(product: Product) {

		if (DeviceStatusFun.getVmcState(this.deviceStatus) === "Inactive"){
			this.app.status.reportUserActivity();
		}

		// When product is disabled, ignore click
		if (!this.productIsAvailable(product)) {
			console.error("product not available!",product);
			return;
		}

		//TODO UI Design klären!
		if (this.isCartFull()) {
			console.error(`Cart maximum of ${this.cartMaximum} exceeded!`);
			return;
		}


		// Set selected button for use in following pages
		//this.appStatusService.setSelectedProduct(findProductBase(this.menu,product));
		await this.app.status.reportUserActivity();
		// Order product
		try {
			await this.app.api.orderApi.cancel(false);
			await this.app.api.cartApi.add(product.ID);
			await this.app.api.orderApi.orderCart();

			return true;
		} catch (e) {
			console.error(e);
			this.app.nav.openPageAndReportUserActivity(`/${this.theme}/warning`);
		}

	}

	productIsAvailable(product: Product): boolean {
		let enabled: boolean = true;

		/* NO! // If there is a product voucher, enable only the possible products/options
		const voucher = this.deviceStatus.PaymentStatus.Credit.Voucher;
		let voucherPattern: string = '';

		if (voucher && voucher.Value === 'Product') {
			voucherPattern = voucher.ProductID;
			enabled = (!voucherPattern || matchesPattern(product.ID, voucherPattern));
		} */

		// Disable all products where resources are missing
		if (this.deviceStatus.MachineStatus.AvailableResources != null) {
			if (false === containsAll(product.Resources, this.deviceStatus.MachineStatus.AvailableResources)) {
				enabled = false;
			}

		}
		return enabled;
	}

	isCartFull(): boolean {
		let count = this.deviceStatus.VendingStatus.Cart.Items.length;
		return count >= this.cartMaximum;
	}

	getPrice(product: Product): Cents {
		let price = product.Price || 0;
		let productPrice: ProductPrice = nullSafe(() => this.pricelist.DefaultPriceList.Prices.find(it => {
			return it.ProductID === product.ID;
		}));
		if (productPrice && productPrice.Price) {
			price = productPrice.Price;
		}

		return price;
	}

	getDeposit(product: Product): Cents {

		let deposit = product.Deposit || 0;
		let productPrice: ProductPrice = nullSafe(() => this.pricelist.DefaultPriceList.Prices.find(it => {
			return it.ProductID === product.ID;
		}));
		if (productPrice && productPrice.Deposit) {
			deposit = productPrice.Deposit;
		}
		return deposit;
	}

	getImage(image: string) {
		return this.app.api.dataApi.getImageUrl(image);
	}
}
